// extracted by mini-css-extract-plugin
export default {"container":"DYEgB","title":"EUaXh","postsList":"HJ9-r","postListItem":"gSX34"};